var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { BANK_MASTER, EXPLORE_CLIENT_NAME_FILTERS, EXPLORE_INVESTMENT_VALUE_FILTERS, EXPLORE_ORDER_BOOK_CANCEL_ORDER, EXPLORE_ORDER_BOOK_CLIENT_PAN, EXPLORE_ORDER_BOOK_DOWNLOAD_DATA, EXPLORE_ORDER_BOOK_DUPLICATE_ORDER, EXPLORE_PRODUCT_TYPES_FILTERS, EXPLORE_STATUS_FILTERS, ORDER_BOOK_DETAILS_REQUEST_PAYLOAD, ORDER_BOOK_FILTER_REQUEST_PAYLOAD, ORDER_BOOK_RESEND_CONSENT_REQUEST_PAYLOAD, ORDER_BOOK_TABLE_NCD_REQUEST_PAYLOAD, ORDER_BOOK_TABLE_NCD_SCHEMES, ORDER_BOOK_TABLE_REQUEST_PAYLOAD, ORDER_BOOK_TABLE_SCHEMES, ORDER_BOOK_TIME_LINE, SET_SUSPENSE_FORM, UPDATE_IS_REFUND_REASON_SELECTED, UPDATE_MODIFY_PAYMENT_MODE, UPDATE_MODIFY_PAYMENT_MODE_DOC, UPDATE_PREVIEW_SUSPENSE_DOCS, UPDATE_REFUND, UPDATE_REFUND_NCD_TYPE, UPDATE_REFUND_TYPE, UPDATE_SELECTED_REFUND_REASON, UPDATE_SELECTED_REFUND_TYPE, UPDATE_SUSPENSE_REFUND, UPDATE_UPLOAD_SUSPENSE_DOCS, UPDATE_VALIDATE_INTEREST, UPDATE_VALIDATE_UTR, } from "../interface/IOrderbook";
var initState = {
    orderBookTable: null,
    orderBookRequestPayload: null,
    orderBookDetails: null,
    orderBookFilter: null,
    orderBookResendConsent: null,
    orderBookNcdTable: null,
    orderBookNcdRequestPayload: null,
    orderBookTimeline: null,
    refundType: null,
    refundNcdType: null,
    selectedRefundType: null,
    isRefundReasonSelected: true,
    selectedRefundReason: {
        id: 1,
        name: "",
        refund_description: "",
    },
    validateInterest: null,
    validateUtr: null,
    suspenseRefund: null,
    refund: null,
    previewSuspenseDoc: null,
    bankMaster: null,
    suspenseFormData: {
        bankName: { label: "", value: "" },
        accountNumber: "",
        ifscCode: "",
        clientPan: {
            order_id: 0,
            sell_reference_no: "",
            acc_code: "",
            client_name: "",
            pan: "",
        },
        amount: "",
        utrOrChequeNo: "",
        bankProof: null,
    },
    productProductTypesFilters: null,
    productClientNameFilters: null,
    productInvestmentValueFilters: null,
    productStatusFilters: null,
    orderBookDownloadData: null,
    cancelOrder: null,
    duplicateOrder: null,
    clientPanData: null,
    modifyPaymentMode: null,
    modifyPaymentModeDoc: null,
};
var orderBookReducer = function (state, action) {
    if (state === void 0) { state = initState; }
    switch (action.type) {
        case EXPLORE_ORDER_BOOK_CANCEL_ORDER:
            return __assign(__assign({}, state), { cancelOrder: action.payload.cancelOrder });
        case UPDATE_MODIFY_PAYMENT_MODE:
            return __assign(__assign({}, state), { modifyPaymentMode: action.payload.modifyPaymentMode });
        case UPDATE_MODIFY_PAYMENT_MODE_DOC:
            return __assign(__assign({}, state), { modifyPaymentModeDoc: action.payload.modifyPaymentModeDoc });
        case EXPLORE_ORDER_BOOK_DUPLICATE_ORDER:
            return __assign(__assign({}, state), { duplicateOrder: action.payload.duplicateOrder });
        case ORDER_BOOK_TIME_LINE:
            return __assign(__assign({}, state), { orderBookTimeline: action.payload.orderBookTimeline });
        case EXPLORE_ORDER_BOOK_DOWNLOAD_DATA:
            return __assign(__assign({}, state), { orderBookDownloadData: action.payload.orderBookDownloadData });
        case ORDER_BOOK_TABLE_SCHEMES:
            return __assign(__assign({}, state), { orderBookTable: action.payload.orderBookTable });
        case ORDER_BOOK_TABLE_NCD_SCHEMES:
            return __assign(__assign({}, state), { orderBookNcdTable: action.payload.orderBookNcdTable });
        case ORDER_BOOK_DETAILS_REQUEST_PAYLOAD:
            return __assign(__assign({}, state), { orderBookDetails: action.payload.orderBookDetails });
        case ORDER_BOOK_FILTER_REQUEST_PAYLOAD:
            return __assign(__assign({}, state), { orderBookFilter: action.payload.orderBookFilter });
        case ORDER_BOOK_RESEND_CONSENT_REQUEST_PAYLOAD:
            return __assign(__assign({}, state), { orderBookResendConsent: action.payload.orderBookResendConsent });
        case ORDER_BOOK_TABLE_REQUEST_PAYLOAD:
            return __assign(__assign({}, state), { orderBookRequestPayload: action.payload.orderBookRequestPayload });
        case ORDER_BOOK_TABLE_NCD_REQUEST_PAYLOAD:
            return __assign(__assign({}, state), { orderBookNcdRequestPayload: action.payload.orderBookNcdRequestPayload });
        case UPDATE_REFUND_TYPE:
            return __assign(__assign({}, state), { refundType: action.payload.refundType });
        case UPDATE_REFUND_NCD_TYPE:
            return __assign(__assign({}, state), { refundNcdType: action.payload.refundNcdType });
        case UPDATE_SELECTED_REFUND_TYPE:
            return __assign(__assign({}, state), { selectedRefundType: action.payload.selectedRefundType });
        case UPDATE_IS_REFUND_REASON_SELECTED:
            return __assign(__assign({}, state), { isRefundReasonSelected: action.payload.isRefundReasonSelected });
        case EXPLORE_ORDER_BOOK_CLIENT_PAN:
            return __assign(__assign({}, state), { clientPanData: action.payload.clientPanData });
        case UPDATE_SELECTED_REFUND_REASON:
            return __assign(__assign({}, state), { selectedRefundReason: action.payload.selectedRefundReason });
        case UPDATE_VALIDATE_INTEREST:
            return __assign(__assign({}, state), { validateInterest: action.payload.validateInterest });
        case UPDATE_VALIDATE_UTR:
            return __assign(__assign({}, state), { validateUtr: action.payload.validateUtr });
        case UPDATE_SUSPENSE_REFUND:
            return __assign(__assign({}, state), { suspenseRefund: action.payload.suspenseRefund });
        case UPDATE_REFUND:
            return __assign(__assign({}, state), { refund: action.payload.refund });
        case UPDATE_PREVIEW_SUSPENSE_DOCS:
            return __assign(__assign({}, state), { previewSuspenseDoc: action.payload.previewSuspenseDoc });
        case UPDATE_UPLOAD_SUSPENSE_DOCS:
            return __assign(__assign({}, state), { uploadSuspenseDoc: action.payload.uploadSuspenseDoc });
        case BANK_MASTER:
            return __assign(__assign({}, state), { bankMaster: action.payload.bankMaster });
        case SET_SUSPENSE_FORM:
            return __assign(__assign({}, state), { suspenseFormData: action.payload.suspenseFormData });
        case EXPLORE_PRODUCT_TYPES_FILTERS:
            return __assign(__assign({}, state), { productProductTypesFilters: action.payload.productProductTypesFilters });
        case EXPLORE_STATUS_FILTERS:
            return __assign(__assign({}, state), { productStatusFilters: action.payload.productStatusFilters });
        case EXPLORE_CLIENT_NAME_FILTERS:
            return __assign(__assign({}, state), { productClientNameFilters: action.payload.productClientNameFilters });
        case EXPLORE_INVESTMENT_VALUE_FILTERS:
            return __assign(__assign({}, state), { productInvestmentValueFilters: action.payload.productInvestmentValueFilters });
        default:
            return __assign({}, state);
    }
};
export default orderBookReducer;
